import { DataArray, IDataArray, Section  } from './../../shared/index';

export class SectionPermission implements IDataArray {
    public SectionId: number;
    public UserId: number;
    public Allowed: boolean;
    public Name: string;

    public GetById(): number {
        return this.SectionId;
    }
}
